/**
 * mainTabActiveContext — keep-alive 메인 탭 슬롯의 "활성(=화면에 보임)" 여부.
 *
 * 배경:
 *   메인 탭 4개는 keep-alive(unmount 안 함, display:none 토글)라 마운트 여부만으로는
 *   "지금 이 탭이 보이는가"를 알 수 없다. refetchInterval 폴링 같은 마운트-기반 동작이
 *   숨김 상태에서도 계속 도는 문제가 생김 → Layout 이 슬롯별로 이 컨텍스트를 주입해
 *   각 탭 페이지가 자신의 노출 여부에 따라 폴링/구독을 게이트할 수 있게 한다.
 *
 * 기본값 true:
 *   슬롯 밖 렌더(테스트, 단독 라우트 렌더 등)에서는 "보인다"로 간주 — 게이트가
 *   실수로 데이터를 굶기지 않도록 안전한 쪽으로 폴백.
 */
import { createContext, useContext } from "react";

export const MainTabActiveContext = createContext<boolean>(true);

/** 현재 컴포넌트가 속한 keep-alive 메인 탭 슬롯이 활성(노출) 상태인지. */
export function useMainTabActive(): boolean {
  return useContext(MainTabActiveContext);
}
